export default "__VITE_ASSET__CyCNuO8V__"